<!--
 * @Description:
 * @version:
 * @Author: 陈朋
 * @Date: 2021-11-17 09:39:05
 * @LastEditors: sueRim
 * @LastEditTime: 2021-11-17 10:36:36
-->
<template>
  <div class="wrap">
    <div class="content ub ub-pb">
      <div class="left-part ub ub-f1">
        <slot name="left-part"></slot>
      </div>
      <div class="right-part ub ub-f1">
        <slot name="right-part"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, Comment } from "vue";

export default defineComponent({
  isGlobal: true,
  name: "EqualShare",
});
</script>

<style lang="less">
@import "./index";
</style>
